import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../ui';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';

const PAGES = [
  ['Overview', '/', 'LayoutDashboard'], ['Greenhouses', '/fields', 'Sprout'], ['Stations', '/stations', 'RadioTower'], ['Alerts', '/alerts', 'BellRing'],
  ['Live console', '/live', 'Activity'], ['Analytics', '/analytics', 'BarChart3'], ['System & simulator', '/system', 'Server'], ['Settings', '/settings', 'Settings'], ['Help & glossary', '/help', 'LifeBuoy'],
];

export default function CommandPalette({ open, onClose, onTour }) {
  const nav = useNavigate();
  const { data } = useData();
  const { logout } = useAuth();
  const [q, setQ] = useState('');
  const [idx, setIdx] = useState(0);
  const input = useRef();

  useEffect(() => { if (open) { setQ(''); setIdx(0); setTimeout(() => input.current?.focus(), 30); } }, [open]);

  const items = useMemo(() => {
    const out = PAGES.map(([label, to, icon]) => ({ group: 'Pages', label, icon, run: () => nav(to) }));
    (data?.farms || []).forEach((f) => {
      out.push({ group: 'Greenhouses', label: f.name, hint: `${f.culture} · ${f.adress}`, icon: 'Sprout', run: () => nav(`/fields/${f._id}`) });
      f.stations.forEach((s) => out.push({ group: 'Stations', label: s.name, hint: `Station ${s.number}`, icon: 'RadioTower', run: () => nav(`/stations?open=${s._id}`) }));
    });
    out.push(
      { group: 'Actions', label: 'Start the guided tour', icon: 'Compass', run: onTour },
      { group: 'Actions', label: 'Sign out', icon: 'LogOut', run: logout },
    );
    const s = q.trim().toLowerCase();
    return s ? out.filter((i) => `${i.label} ${i.hint || ''} ${i.group}`.toLowerCase().includes(s)) : out;
  }, [data, q, nav, onTour, logout]);

  if (!open) return null;
  const choose = (it) => { onClose(); it.run(); };
  const onKey = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setIdx((i) => Math.min(i + 1, items.length - 1)); }
    if (e.key === 'ArrowUp') { e.preventDefault(); setIdx((i) => Math.max(i - 1, 0)); }
    if (e.key === 'Enter' && items[idx]) choose(items[idx]);
    if (e.key === 'Escape') onClose();
  };
  let last = '';
  return (
    <>
      <div className="overlay" onClick={onClose} />
      <div className="cmdk" role="dialog" aria-label="Command palette">
        <input ref={input} value={q} onChange={(e) => { setQ(e.target.value); setIdx(0); }} onKeyDown={onKey} placeholder="Jump to a greenhouse, station or page…" aria-label="Search" />
        <div className="cmdk__list">
          {items.length === 0 && <div className="empty">Nothing matches “{q}”</div>}
          {items.map((it, i) => {
            const head = it.group !== last ? <div key={`g${it.group}${i}`} className="cmdk__group">{it.group}</div> : null;
            last = it.group;
            return (
              <React.Fragment key={`${it.group}${it.label}${i}`}>
                {head}
                <button className={`cmdk__item ${i === idx ? 'on' : ''}`} onMouseEnter={() => setIdx(i)} onClick={() => choose(it)}>
                  <Icon name={it.icon} size={17} /><span>{it.label}</span>{it.hint && <span className="faint small" style={{ marginLeft: 'auto' }}>{it.hint}</span>}
                </button>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
}
